import _ from "lodash";
import type { IState } from "reducers/scope";
import { ADAPTER_TYPE } from "constants/shipping";
import { getOrder } from "components/build-order";
import type { IStore } from "reducers";
import { format } from "lib/globalize-util";

const REQUIRED_WAREHOUSE_FIELDS = ["postal_code", "country_code"];
export const isBrandConfiguredForShipping = (brand: IState["brand"]) => {
    return (
        brand?.modules.shipping?.enabled &&
        _.every(brand?.settings.warehouses, (w) => _.every(REQUIRED_WAREHOUSE_FIELDS, (f) => w[f])) && // has valid warehouses
        (_.size(brand?.settings.warehouses) <= 1 || _.includes(brand?.settings.order_split_fields, "warehouse")) // has valid settings
    );
};
export const shouldFetchCarriers = ({ cart, scope: { brand } }: IStore): boolean => {
    const order = getOrder(cart);
    if (!brand || !order) {
        return false;
    }
    const noShipToOrders = brand.getPreference("no_ship_to_orders");
    if (noShipToOrders && order.order_type === noShipToOrders) {
        return false;
    }

    const adapter = brand.getPreference("shipping_adapter");
    const canShip =
        (adapter === ADAPTER_TYPE.SHIP_ENGINE && order.currency_code === "USD") || adapter === ADAPTER_TYPE.STATIC; // may have to extend this in the future
    return isBrandConfiguredForShipping(brand) && canShip && !cart.isBulkOrder;
};

export const formatCarriersResponse = ({ data, error }: { data: []; error: boolean }) => ({
    data,
    error:
        (error && format("Shipping service unavailable")) ||
        (!_.isNull(data) && _.isEmpty(data) && format("No carriers found")) ||
        null,
});
